/* 🤖 this file was generated by svg-to-ts */
export const siriusPersonSimpleCircleDuotone: {
  name: 'person_simple_circle_duotone';
  data: string;
} = {
  name: 'person_simple_circle_duotone',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" style="display: block;"><path opacity=".2" d="M21 12a9 9 0 1 1-17.999 0A9 9 0 0 1 21 12Z" fill="currentColor"/><path d="M12 2.25A9.75 9.75 0 1 0 21.75 12 9.76 9.76 0 0 0 12 2.25Zm0 18A8.25 8.25 0 1 1 20.25 12 8.26 8.26 0 0 1 12 20.25ZM10.5 7.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0Zm6.75 3a.75.75 0 0 1-.75.75h-3.75v1.273l2.874 4.313a.75.75 0 1 1-1.248.832L12 14.106l-2.376 3.562a.751.751 0 0 1-1.248-.832l2.874-4.313V11.25H7.5a.75.75 0 1 1 0-1.5h9a.75.75 0 0 1 .75.75Z" fill="currentColor"/></svg>`
};
